export default {
  GRAVATAR_URL: 'https://www.gravatar.com/avatar/',
  ASSIGNEE_TYPE: {
    ME: 'me',
    UNASSIGNED: 'unassigned',
    ALL: 'all',
  },
  STATUS_TYPE: {
    OPEN: 'open',
    RESOLVED: 'resolved',
    PENDING: 'pending',
    SNOOZED: 'snoozed',
    ALL: 'all',
  },
  SORT_BY_TYPE: {
    LAST_ACTIVITY_AT_ASC: 'last_activity_at_asc',
    LAST_ACTIVITY_AT_DESC: 'last_activity_at_desc',
    CREATED_AT_ASC: 'created_at_asc',
    CREATED_AT_DESC: 'created_at_desc',
    PRIORITY_ASC: 'priority_asc',
    PRIORITY_DESC: 'priority_desc',
    PRIORITY_CREATED_AT_ASC: 'priority_created_at_asc',
    PRIORITY_CREATED_AT_DESC: 'priority_created_at_desc',
    WAITING_SINCE_ASC: 'waiting_since_asc',
    WAITING_SINCE_DESC: 'waiting_since_desc',
  },
  ARTICLE_STATUS_TYPES: {
    DRAFT: 0,
    PUBLISH: 1,
    ARCHIVE: 2,
  },
  LAYOUT_TYPES: {
    CONDENSED: 'condensed',
    EXPANDED: 'expanded',
  },
  DOCS_URL: 'https://www.chatwoot.com/docs/product/',
  HELP_CENTER_DOCS_URL:
    'https://www.chatwoot.com/docs/product/others/help-center',
  TESTIMONIAL_URL: 'https://testimonials.cdn.chatwoot.com/content.json',
  SMALL_SCREEN_BREAKPOINT: 1200,
  // Below this width (Tailwind md) the sidebar and the contact panel are overlays
  MOBILE_SCREEN_BREAKPOINT: 768,
  AVAILABILITY_STATUS_KEYS: ['online', 'busy', 'offline'],
  SNOOZE_OPTIONS: {
    UNTIL_NEXT_REPLY: 'until_next_reply',
    AN_HOUR_FROM_NOW: 'an_hour_from_now',
    UNTIL_TOMORROW: 'until_tomorrow',
    UNTIL_NEXT_WEEK: 'until_next_week',
    UNTIL_NEXT_MONTH: 'until_next_month',
    UNTIL_CUSTOM_TIME: 'until_custom_time',
  },
  EXAMPLE_URL: 'example.com',
  EXAMPLE_WEBHOOK_URL: 'https://example/api/webhook',
  INBOX_SORT_BY: {
    NEWEST: 'desc',
    OLDEST: 'asc',
  },
  INBOX_DISPLAY_BY: {
    SNOOZED: 'snoozed',
    READ: 'read',
  },
  INBOX_FILTER_TYPE: {
    STATUS: 'status',
    TYPE: 'type',
    SORT_ORDER: 'sort_order',
  },
  SLA_MISS_TYPES: {
    FRT: 'frt',
    NRT: 'nrt',
    RT: 'rt',
  },
  COLORS: {
    red: {
      light: '#FF0000',
      dark: '#DC0303',
      description: 'Red',
    },
    yellow: {
      light: '#FFBF05',
      dark: '#E8C75E',
      description: 'Yellow',
    },
    blue: {
      light: '#0000FF',
      dark: '#272DE8',
      description: 'Blue',
    },
    rose_red: {
      light: '#C12161',
      dark: '#BC3F6D',
      description: 'Rose Red',
    },
    deep_cyan: {
      light: '#007181',
      dark: '#177A83',
      description: 'Deep Cyan',
    },
    orange: {
      light: '#FF6A00',
      dark: '#E87D27',
      description: 'Orange',
    },
    pistachio: {
      light: '#A9E694',
      dark: '#93C781',
      description: 'Pistachio',
    },
    purple: {
      light: '#6638D9',
      dark: '#7B52E0',
      description: 'Purple',
    },
    fuchsia: {
      light: '#FF00FF',
      dark: '#E827E1',
      description: 'Fuchsia',
    },
    silver: {
      light: '#999999',
      dark: '#BABABA',
      description: 'Silver',
    },
    navy: {
      light: '#151882',
      dark: '#6A72A5',
      description: 'Navy',
    },
    old_pink: {
      light: '#CF809E',
      dark: '#E8C1CD',
      description: 'Old Pink',
    },
    aqua: {
      light: '#00D2D9',
      dark: '#4FF3E8',
      description: 'Aqua',
    },
    brown: {
      light: '#664933',
      dark: '#9F704C',
      description: 'Brown',
    },
    olive: {
      light: '#665E00',
      dark: '#A9AE54',
      description: 'Olive',
    },
    gold: {
      light: '#D9B100',
      dark: '#E8D127',
      description: 'Gold',
    },
    indigo: {
      light: '#4B0082',
      dark: '#A072B2',
      description: 'Indigo',
    },
    cold_brown: {
      light: '#94766F',
      dark: '#AA877F',
      description: 'Cold Brown',
    },
    coral: {
      light: '#FF4E49',
      dark: '#FF7260',
      description: 'Coral',
    },
    azure: {
      light: '#00C7FC',
      dark: '#4FDBF3',
      description: 'Azure',
    },
    lila: {
      light: '#B18CFE',
      dark: '#997ADB',
      description: 'Lila',
    },
    lemon: {
      light: '#F5EC00',
      dark: '#E8E827',
      description: 'Lemon',
    },
    beige: {
      light: '#938576',
      dark: '#DCCCB8',
      description: 'Beige',
    },
    wine: {
      light: '#791A3E',
      dark: '#8B4A5F',
      description: 'Wine',
    },
    forest: {
      light: '#004528',
      dark: '#297F53',
      description: 'Forest',
    },
    green: {
      light: '#3f784f',
      dark: '#39E86D',
      description: 'Green',
    },
    blue_grey: {
      light: '#8AA0E2',
      dark: '#788BC3',
      description: 'Blue Grey',
    },
    ruby_red: {
      light: '#CF1840',
      dark: '#B31739',
      description: 'Ruby Red',
    },
    chestnut_brown: {
      light: '#A44A2B',
      dark: '#A05F45',
      description: 'Chestnut Brown',
    },
    ash_grey: {
      light: '#6e776e',
      dark: '#BBCCC1',
      description: 'Ash Grey',
    },
  },
};
export const DEFAULT_REDIRECT_URL = '/app/';
